var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H29C35.6274 0 41 5.37258 41 12V29C41 35.6274 35.6274 41 29 41H12C5.37258 41 0 35.6274 0 29V12Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.709 12.5C19.5373 12.5 18.4135 12.9655 17.585 13.794C16.7565 14.6225 16.291 15.7462 16.291 16.9179V17.887C15.2825 18.0052 14.5 18.8627 14.5 19.903V26.4702C14.5 27.5912 15.4088 28.5 16.5299 28.5H24.8881C26.0091 28.5 26.9179 27.5912 26.9179 26.4702V19.903C26.9179 18.8627 26.1354 18.0052 25.1269 17.887V16.9179C25.1269 15.7462 24.6614 14.6225 23.8329 13.794C23.0044 12.9655 21.8807 12.5 20.709 12.5ZM23.4552 17.8731V16.9179C23.4552 16.1896 23.1659 15.491 22.6509 14.976C22.1358 14.461 21.4373 14.1716 20.709 14.1716C19.9806 14.1716 19.2821 14.461 18.7671 14.976C18.252 15.491 17.9627 16.1896 17.9627 16.9179V17.8731H23.4552ZM16.1716 19.903C16.1716 19.7052 16.332 19.5448 16.5299 19.5448H24.8881C25.0859 19.5448 25.2463 19.7052 25.2463 19.903V26.4702C25.2463 26.668 25.0859 26.8284 24.8881 26.8284H16.5299C16.332 26.8284 16.1716 26.668 16.1716 26.4702V19.903Z",
    fill: "#C4C4C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.568a5a8dd18bb3ef96bcaf97bb44decc.svg";
export { ForwardRef as ReactComponent };